module.exports = __webpack_public_path__ + "img/company-honor-RoHS-20241023.7fd5cfdd.jpg";